var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-start"},[_c('span',[_c('v-icon',{staticClass:"mr-1"},[_vm._v(_vm._s(_vm.resolveIcon(_vm.packingMode)))])],1),_c('span',[_vm._v(" "+_vm._s(_vm.packingMode.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }